module.exports = __webpack_public_path__ + "static/media/banner-mobile.ca205d68.svg";